<template>
    <div v-if="entrega.natureza === 'CONSULTORIA'">
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">RAHT</span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <raht-empresas
                            :raht="raht"
                            :empresas="empresas"
                            :edicaoHabilitada="mostrarBtnSalvar"
                            @inserirEmpresa="inserirEmpresa($event)"
                            @atualizarEmpresa="atualizarEmpresa($event)"
                            @excluirEmpresa="excluirEmpresa($event)"
                        ></raht-empresas>
                        <b-row
                            v-for="(item, index) in raht.itens"
                            :key="item.rahtItemTemplateId"
                        >
                            <b-col sm="12">
                                <b-form-group>
                                    <label class="required">{{
                                        item.titulo
                                    }}</label>
                                    <b-form-textarea
                                        v-model="raht.itens[index].conteudo"
                                        :rows="4"
                                        :disabled="desabilitarFormulario"
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer v-if="mostrarBtnSalvar">
                        <b-button
                            variant="primary"
                            @click.stop="confirmaAtualizarEntregaRaht()"
                            :disabled="desabilitarSalvar"
                            v-if="mostrarBtnSalvar"
                        >
                            <span> <i class="fa fa-floppy-o"></i> Salvar </span>
                        </b-button>
                        <div class="float-right">
                            <label class="required ml-3 pt-2"></label>
                            <label class="ml-2 pt-2">Campos Obrigatórios</label>
                        </div>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import RahtEmpresas from './RahtEmpresas'

export default {
    components: {
        RahtEmpresas
    },

    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            raht: {},
            empresas: []
        }
    },

    methods: {
        verificarPreenchimentoRaht() {
            let camposVazios = []
            for (let index = 0; index < this.raht.itens.length; index++) {
                const element = this.raht.itens[index]
                if (!element.conteudo || element.conteudo.trim() == '') {
                    camposVazios.push(element.titulo)
                }
            }
            return camposVazios
        },

        preencherFormulario() {
            this.raht.rahtId = this.entrega.raht.rahtId
            this.raht.entregaId = this.entrega.entregaId
            this.raht.itens = [...this.entrega.raht.itens]
            this.raht.empresas = [...this.entrega.raht.empresas]
            this.empresas = [...this.raht.empresas]
        },

        confirmaAtualizarEntregaRaht() {
            let camposVazios = this.verificarPreenchimentoRaht()
            if (camposVazios.length > 0) {
                this.$swal({
                    title: 'Atualização da RAHT',
                    html: `O${camposVazios.length > 1 ? 's' : ''} campo${
                        camposVazios.length > 1 ? 's' : ''
                    } <strong>${camposVazios.join(' / ')}</strong> não ${
                        camposVazios.length > 1 ? 'foram' : 'foi'
                    } preenchido${camposVazios.length > 1 ? 's' : ''}!!!`,
                    icon: 'error'
                })
            } else {
                this.$swal({
                    title: 'Atualização da RAHT',
                    html: `Confirma a atualização da RAHT?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.atualizarEntregaRaht()
                    }
                })
            }
        },

        atualizarEntregaRaht() {
            this.$store.dispatch('addRequest')
            this.entregasServicos
                .atualizarEntregaRaht(this.raht)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.erros = response.errors
                            // this.$toast.error(
                            //     response.errors,
                            //     'ERROR',
                            //     this.$toastConfig.error
                            // )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirEmpresa(empresa) {
            this.raht.empresas.push(empresa)
            this.empresas = [...this.raht.empresas]
        },

        atualizarEmpresa(empresa) {
            for (let index = 0; index < this.raht.empresas.length; index++) {
                const empresaAtual = this.raht.empresas[index]
                if (empresaAtual.documento == empresa.documento) {
                    this.raht.empresas[index].nome = empresa.nome
                    this.raht.empresas[index].qtdHoras = empresa.qtdHoras
                    break
                }
            }
            this.empresas = [...this.raht.empresas]
        },

        excluirEmpresa(empresa) {
            for (let index = 0; index < this.raht.empresas.length; index++) {
                const empresaAtual = this.raht.empresas[index]
                if (empresaAtual.documento == empresa.documento) {
                    this.raht.empresas.splice(index, 1)
                    break
                }
            }
            this.empresas = [...this.raht.empresas]
        }
    },

    validations: {
        preenchimentoRaht: {
            camposOk() {
                return this.raht.itens.every(
                    item => item.conteudo != null && item.conteudo.trim() != ''
                )
            }
        }
    },

    watch: {
        entrega() {
            this.preencherFormulario()
        }
    },

    computed: {
        desabilitarFormulario() {
            return (
                !this.$temAcesso('CRED-FORN-ENTR-04') ||
                (this.entrega.status !== 0 && this.entrega.status !== 3)
            )
        },

        mostrarBtnSalvar() {
            return (
                this.$temAcesso('CRED-FORN-ENTR-04') &&
                (this.entrega.status === 0 || this.entrega.status === 3)
            )
        },

        desabilitarSalvar() {
            // return this.$v.$invalid
            return false
        }
    }
}
</script>
